import { initFulfilledRidesChart } from "./initFulfilledRidesChart";

export const fulfilledRidesChart = {
  initFulfilledRidesChart,
};
